import { type PaymentSettings } from 'digital-settings/common/entities'
import { httpClientVendasCoreBff } from 'vendas-core/shared/services'

import { type UseQueryRequestOptions, useQueryRequest } from '~/ui/hooks/utils/service/use-query-request'

async function getPaymentSettings(paymentProfileId: string): Promise<PaymentSettings> {
  const { data } = await httpClientVendasCoreBff<PaymentSettings>({
    url: `/v1/payment-profile/${paymentProfileId}/payments-settings`,
    method: 'GET'
  })
  return data
}

export function useGetPaymentsSettings(
  paymentProfileId?: string,
  options?: UseQueryRequestOptions<PaymentSettings, unknown, true> & { enabled?: boolean }
) {
  return useQueryRequest<PaymentSettings, unknown, true>(
    ['useGetPaymentsSettings', paymentProfileId] as const,
    () => getPaymentSettings(paymentProfileId!),
    {
      enabled: Boolean(paymentProfileId) && (options?.enabled ?? true),
      ...options
    }
  )
}
